import { render } from "./BaseInfoIcon.vue?vue&type=template&id=7231f2ca"
import script from "./BaseInfoIcon.vue?vue&type=script&lang=js"
export * from "./BaseInfoIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__